const FndUserRoleFields = [
    {
        name: '角色名称',
        code: 'roleName',
        column: true,
        sortable:false,
        defaultFilter: true,
        width: 100
    },
    {
        name: '角色编码',
        code: 'roleCode',
        column: true,
        sortable:false,
        defaultFilter: true,
        width: 100
    },
    {
        name: '描述',
        code: 'description',
        align: 'center',
        sortable:false,
        defaultFilter: true,
        width: 180
    }
]
export default FndUserRoleFields;